import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-326fdb82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-content" }, [
  /*#__PURE__*/_createTextVNode(" 当前识别到您的"),
  /*#__PURE__*/_createElementVNode("span", null, "设备已经脱保"),
  /*#__PURE__*/_createTextVNode("，需要"),
  /*#__PURE__*/_createElementVNode("span", null, "通过验机后可购买保险"),
  /*#__PURE__*/_createTextVNode("。验机形式为自动验机，系统会自动分析日志判断设备状态。 ")
], -1))
const _hoisted_3 = { class: "step-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-num-wrap" }, [
  /*#__PURE__*/_createElementVNode("span", null, "1"),
  /*#__PURE__*/_createTextVNode("安全环境起飞")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "确保设备在空旷安全环境起飞", -1))
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-num-wrap" }, [
  /*#__PURE__*/_createElementVNode("span", null, "2"),
  /*#__PURE__*/_createTextVNode("设备悬停 3 分钟")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "操作设备起飞悬停 3 分钟", -1))
const _hoisted_9 = ["src"]

import { ImagePreview } from 'vant'
import { withDefaults } from 'vue'
import CommonPopupWrap from '@/components/popup/common-wrap.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'before-check',
  props: {
    show: { type: Boolean, default: false }
  },
  emits: ['update:show', 'confirmStart'],
  setup(__props: any, { emit: emits }) {

const props = __props as { show: boolean };



const imageList = [
  'https://static.knowledge.xag.cn/img/jijia2024/before-check-1.png',
  'https://static.knowledge.xag.cn/img/jijia2024/before-check-2.png',
]

function updateShow(value: boolean) {
  emits('update:show', value)
}

function imagePreviewHandle(num: number) {
  ImagePreview({
    images: imageList,
    startPosition: num,
  })
}
function startCheckHandle() {
  emits('confirmStart')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CommonPopupWrap, {
    show: props.show,
    teleport: "body",
    title: "温馨提示",
    "onUpdate:show": updateShow,
    "header-style": {
      backgroundColor: 'white',
    }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("img", {
              src: imageList[0],
              alt: "",
              class: "image",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (imagePreviewHandle(0)))
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", null, [
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("img", {
              src: imageList[1],
              alt: "",
              class: "image",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (imagePreviewHandle(1)))
            }, null, 8, _hoisted_9)
          ])
        ]),
        _createVNode(CommonFooterNextButton, {
          title: "开始验机",
          onClick: startCheckHandle
        })
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})